module.exports = __webpack_public_path__ + "img/pellets-dust-protection.04caae9.svg";